module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }), _c('h2', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgement#ack"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#chap1"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" ‘Death is Lighter than a Feather’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Desperate Measures")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" ‘A Splendid Opportunity to Die’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Fall of the Philippines")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Developments and Defences")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Floating Chrysanthemum")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The Fall of Okinawa")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" ‘To Bear the Unbearable’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" ‘The Moon Rose Radiant’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])]), _c('a', {
    attrs: {
      "id": "pagevi",
      "title": "vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagevi",
      "title": "vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d96caff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_toc.vue
// module id = 66
// module chunks = 0